import {
  ColourController,
  ColourControllerProps,
} from "@/components/inspector/controller/ColourController";
import {
  ImageController,
  ImageControllerProps,
} from "@/components/inspector/controller/ImageController";
import {
  SelectController,
  SelectControllerProps,
} from "@/components/inspector/controller/SelectController";
import {
  SliderController,
  SliderControllerProps,
} from "@/components/inspector/controller/SliderController";

export const Controller = {
  colour: "colour",
  image: "image",
  select: "select",
  slider: "slider",
} as const;
export type ControllerType = keyof typeof Controller;

export type ControllerProps =
  | (ColourControllerProps & { type: typeof Controller.colour; label: string })
  | (ImageControllerProps & { type: typeof Controller.image; label: string })
  | (SelectControllerProps & { type: typeof Controller.select; label: string })
  | (SliderControllerProps & { type: typeof Controller.slider; label: string });

export type ControllerPropsByKey = {
  colour: ColourControllerProps & { type: typeof Controller.colour };
  image: ImageControllerProps & { type: typeof Controller.image };
  select: SelectControllerProps & { type: typeof Controller.select };
  slider: SliderControllerProps & { type: typeof Controller.slider };
};

// export const ControllerComponents: {
//   [key in ControllerType]: React.FC<ControllerPropsByKey[key]>;
// } = {
//   colour: ColourController,
//   image: ImageController,
//   select: SelectController,
//   slider: SliderController,
// };

export const ControllerComponents = (props: ControllerProps) => {
  switch (props.type) {
    case "colour":
      return ColourController(props);
    case "image":
      return ImageController(props);
    case "select":
      return SelectController(props);
    case "slider":
      return SliderController(props);
  }
};
